module.exports = __webpack_public_path__ + "img/2PVRActivate.7c185c1c.png";